import { Suspense, lazy } from 'react'
import { useTheme } from '../hooks/useTheme'
import { useApp } from '../context/AppContext'

const Cart3DScene = lazy(() => import('../components/Cart3DScene'))

export default function CartPage() {
  const { isDark } = useTheme()

  return (
    <div style={{
      position: 'absolute', inset: 0,
      background: isDark ? '#1a1a2e' : '#F5F6FA',
      display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      <Suspense>
        <Cart3DScene />
      </Suspense>
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0,
        textAlign: 'center', padding: '40px 20px 60px',
        pointerEvents: 'none',
      }}>
        <h1 style={{
          fontSize: 28, fontWeight: 700, margin: 0,
          color: isDark ? '#fff' : '#1a1a2e',
          letterSpacing: 4,
        }}>说 灵 灵</h1>
        <p style={{
          fontSize: 14, marginTop: 8,
          color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.4)',
        }}>AI 驱动的智能学习助手</p>
      </div>
    </div>
  )
}
